//Libs
import React, { useState } from "react";
import PaymentIcon from "@mui/icons-material/Payment";
import LoadingSpinner from "./LoadingSpinner";

export const styles = {
  display: "block",
  height: "38px",
  width: "38px",
  cursor: "pointer",
  padding: "6px",
};

type PaymentIconProps = {
  onCreate: () => Promise<void>;
} & React.ComponentPropsWithRef<"button">;

export const PaymentIconWithSpinner = React.forwardRef<
  HTMLButtonElement,
  PaymentIconProps
>(({ onCreate, ...props }, ref): JSX.Element => {
  const [isBusy, setIsBusy] = useState(false);

  return (
    <button
      ref={ref}
      {...props}
      className="mx-1 rounded-full text-gray-700 hover:bg-primaryOpacity90"
      disabled={isBusy}
      onClick={async () => {
        // set animation
        setIsBusy(true);
        try {
          await onCreate();
        } finally {
          // stop animation
          setIsBusy(false);
        }
      }}
    >
      {isBusy ? (
        <LoadingSpinner marginClass="mx-2" />
      ) : (
        <PaymentIcon aria-label="payment link button" style={styles} />
      )}
    </button>
  );
});
